<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <div class="dropdown">
          <ActionButton
            icon="fa-plus"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            id="dropdownMenuButton"
          />

          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenuButton"
          >
            <a
              href="#"
              class="dropdown-item"
              v-for="item in dropdownItems"
              :key="item.route"
              @click="() => navigate(item.route)"
            >
              {{ item.text }}
            </a>
          </div>
        </div>
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ActiveList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ActiveList from "@/components/settings/stock-registers/active/ActiveList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "Active",

  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ActiveList,
  },

  data() {
    return {
      dropdownItems: [
        { text: "Ativo", route: "addactive" },
        { text: "Rastreadores (Em Lote)", route: "addtrackersbatch" },
        { text: "Simcards (Em Lote)", route: "addsimcardsbatch" },
      ],
    };
  },

  methods: {
    navigate(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
